import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmNaturalPerson } from "@natiwi/shared/models/natural-person.model";

export class NatNaturalPersonRepository extends NatCatalogRepository<OrmNaturalPerson> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/naturalPersons';
        let repoModel: Type<OrmNaturalPerson> = OrmNaturalPerson;
        this.init(repoUrl, repoModel);
    }
}